import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { FC, ReactNode } from 'react';
import { Card } from '../../../../../../components/card/card';
import { Table } from '../../../../../../features/table/table';
import s from './tasks-widget.module.css';

interface Props {
  className: string;
  label: string;
  type: 'new' | 'done' | 'fake';
  isExpanded: boolean;
  rows?: Record<string, ReactNode>[];
  count?: number;
}

export const TasksWidget: FC<Props> = (props) => {
  const { className, label, rows, type, isExpanded, count } = props;

  return (
    <Card className={cn(s.feature, className)}>
      <div className={s.header}>
        <h3 className={cn(s.label, s[type])}>{label}</h3>

        <span>{count}</span>
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            key="table"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: '400px', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ type: 'tween' }}
          >
            <Table className={s.table} rows={rows} />
          </motion.div>
        )}
      </AnimatePresence>
    </Card>
  );
};
